<div *ngIf="!signPNG" class="flex justify-center">
  <button (click)="showSignDialog()" [disabled]="disable" class="text-white" color="accent"
          mat-raised-button>Firmar
  </button>
</div>
<div *ngIf="signPNG" class="flex justify-center">
  <div class="w-1/2 relative">
    <img (click)="showSignDialog()" [src]="signPNG"/>
    <mat-icon (click)="showSignDialog()" *ngIf="!hideToPrint" class="absolute bottom-0 right-0">zoom_in</mat-icon>
  </div>

</div>

<ng-template #signDialog>
  <div mat-dialog-title>
    Firmar Documento
  </div>
  <div mat-dialog-content>
    <div class="w-full flex justify-center mb-6">
      <div class="h-[200px] w-[400px] border-2 rounded-2xl shadow">
        <canvas height="190px" id="signature-pad" width="390px"></canvas>
      </div>
    </div>
  </div>
  <div class="flex justify-between" mat-dialog-actions>
    <button (click)="clearSign()" mat-stroked-button>Limpiar Firma</button>
    <button [mat-dialog-close]="true" class="text-white" color="accent" mat-raised-button>Guardar Firma</button>
  </div>
</ng-template>
